module.exports = __webpack_public_path__ + "static/media/nip-red.4ae82598.svg";